import { MenuItemCode } from "../../../Isilog.enums";
import { IIsiDtoGridRows, IIsiDtoGridViewSelectedRowClientState, IsiDtoGridViewSelectedRowClientState, IIsiDtoGridViewSelectedRowsClientState, IsiDtoGridRows, IIsiDtoGridCell, IIsiDtoGridRow, IsiDtoGridRow, IsiDtoGridCells, IsiDtoGridCell, IIsiDtoReorgUI, MoveType, IsiDtoReorgUI } from "../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject.IsiAssociatedView";

export class IsiReorganizationProvider {

    private _action: MenuItemCode;
    /**
     * Constructeur
     */
    constructor() {
    }

    /**
     * Lance le déplacement des lignes 
     * @param action code de l'action monter descendre premier dernier ...
     * @param rows Les lignes à déplacer
     */
    public Move(contextId: string, action: MenuItemCode, rowsSelection: IIsiDtoGridViewSelectedRowsClientState) {
        let dtoReorg: IIsiDtoReorgUI;

        dtoReorg = IsiDtoReorgUI.fromJS({
            rows: this._getRows(rowsSelection),
            moveType: this._getMoveType(action),
            contextId: contextId
        });

        return jQuery.post({
            url: uiCore.getClient().IsiUsedUrl + "/odata/IsiAssociatedView/Move?sessionId=" + uiCore.getIwsSessionId(),
            data: JSON.stringify(dtoReorg),
            contentType: "application/json",
            success: function () { },
            error: function () { },
        });
    }
    /**
     * converti le code l'action en type de mouvement.
     * @param action
     */
    private _getMoveType(action: MenuItemCode): MoveType {
        switch (action) {
            case MenuItemCode.TOP:
                return MoveType.First
            case MenuItemCode.BOTTOM:
                return MoveType.Last
            case MenuItemCode.UP:
                return MoveType.Up
            case MenuItemCode.DOWN:
                return MoveType.Down
        }
    }

    /**
     * Converti la selection en IIsiDtoGridRows
     * @param rowsSelection les lignes selectionnées.
     */
    private _getRows(rowsSelection: IIsiDtoGridViewSelectedRowsClientState): IIsiDtoGridRows {
        let row: IIsiDtoGridViewSelectedRowClientState;
        let rows: IIsiDtoGridRows;
        let rowd: IIsiDtoGridRow;
        let cell: IIsiDtoGridCell;
        rows = IsiDtoGridRows.fromJS({});

        for (let index = 0; index < rowsSelection.rows.length; index++) {
            row = rowsSelection.rows[index];
            rowd = IsiDtoGridRow.fromJS({});
            rowd.cells = IsiDtoGridCells.fromJS({});
            for (let val in row.datas) {
                cell = IsiDtoGridCell.fromJS({});
                cell.key = val;
                cell.value = row.datas[val];
                rowd.cells.all.push(cell)
            }
            rows.all.push(rowd);
        }
        return rows;
    }
}
